<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to My Teams" @click="$router.push('/myteam')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="projects" pageId="project-charges-weekly-review" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                &nbsp;&nbsp;CY {{selectedFiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`">
                            <v-list-tile @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search Date YYYY-MM-DD format" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                     <b>Select weekly period</b>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="weekly_summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" style="cursor:pointer;" title="Click to view details">
                            <td :class="props.item.weekDescription=='Current'?'font-weight-bold':''">
                                {{props.item.weekDescription}}
                            </td>
                            <td>{{props.item.fiscalYear}}</td>
                            <td>{{props.item.weekNumber}}</td>
                            <td>{{props.item.startDate | moment('YYYY-MM-DD')}}</td>
                            <td>{{props.item.endDate | moment('YYYY-MM-DD')}}</td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
    </v-layout> 
</template>

<script>

import projectChargesApi from '@/api/projectcharges'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'ProjectCharges',
    metaInfo: {
        title: 'Project Charges',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Timesheet' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            selectedFiscalYear: userPrefs.getCalendarYear(this.$route.name),
            headers: [
                {text: 'Period',align: 'left',value: 'weekDescription', width: '10%', sortable:true},
                {text: 'Calendar Year',align: 'left',value: 'fiscalYear', width: '10%', sortable:true},
                {text: 'Week Number',align: 'left',value: 'weekNumber', width: '10%', sortable:true},
                {text: 'Start Date',align: 'left',value: 'startDate', width: '10%', sortable:true},
                {text: 'End Date',align: 'left',value: 'endDate',  width: '10%', sortable:true}
            ],
            weekly_summary: [],
            error: false,
            errorMessage: '',
            loading: false,
            search: null,
            menu_status: false,
        }
    },
    methods: {
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            userPrefs.updateCalendarYear(this.$route.name, fiscalYear)
            this.getWeeklySummary()
        },
        viewDetails(data) {
            this.$router.push(`charges/weekly/${data.fiscalYear}/${data.weekNumber}`)
        },  
        async getWeeklySummary() {
            try {
                this.loading = true
                const response = await projectChargesApi.getWeeklySummary(this.fiscalPeriodId)     
                if (response && response.status == 200) {
                    this.weekly_summary = response.data.summaryItems
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Team Project Charges'
        })

        this.getWeeklySummary()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        weekly_summary_filtered() {
            var temp = this.weekly_summary
            
            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.startDate.includes(this.search) || item.endDate.includes(this.search))
                })
            }
            return temp
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        },
        fiscalPeriodId() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
                            .filter(x => x.fiscalYear == this.selectedFiscalYear)[0].fiscalPeriodId
            }
        }
    }
}
</script>